import type { TargetRef } from "../SettingsPayload";

/**
 * 対象参照（{@link TargetRef}）の生成・解釈ヘルパー。
 * 形式は `"slide:<office.js slide id>"` / `"element:<shape creationId (GUID)>"`。
 * element の ID は安定一意な `a16:creationId`（GUID）を用いる（cNvPr id はパッケージ内で
 * 一意でないため不可。[[2026-06-16 設計ノート スライド一括生成アーキテクチャ]] 問題A）。
 */

export type RefKind = "slide" | "element";

/** スライド（ページ）参照を作る。 */
export function makeSlideRef(officeSlideId: string): TargetRef {
    return `slide:${officeSlideId}`;
}

/** 図形（要素）参照を作る。`shapeCreationId`=図形の安定一意 ID（`a16:creationId` GUID）。 */
export function makeElementRef(shapeCreationId: string): TargetRef {
    return `element:${shapeCreationId}`;
}

/** 参照を `{ kind, officeId }` に分解する。未知形式は kind=element 扱い（officeId=全体）。 */
export function parseTargetRef(ref: TargetRef): { kind: RefKind; officeId: string } {
    const sep = ref.indexOf(":");
    if (sep > 0) {
        const prefix = ref.slice(0, sep);
        const officeId = ref.slice(sep + 1);
        if (prefix === "slide") return { kind: "slide", officeId };
        if (prefix === "element") return { kind: "element", officeId };
    }
    return { kind: "element", officeId: ref };
}

/** 参照の種別表示名（UI 用）。スライドは「頁」、要素は「枠」。 */
export function refKindLabel(ref: TargetRef): string {
    return parseTargetRef(ref).kind === "slide" ? "頁" : "枠";
}
